import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';
import PurchaseModel from '@/model/PurchaseModel.js';

/**
 * @method apiGetPurchase
 * @method apiRedeemUse
 */
export default {
    config: function () {
        return Vue.bzbsConfig;
    },

    /**
     * @param {String} bzbsToken
     * @param {Object} listConfig PurchaseListConfigModel - /service/config/HistoryConfigModel.js
     * @param {Object} filterListConfig PurchaseFilterConfigModel - /service/config/HistoryConfigModel.js
     */
    apiGetPurchase: function (bzbsToken, listConfig, filterListConfig) {
        var params = {};

        if (listConfig.strConfigList) {
            params.byConfig = 'true';
            params.config = listConfig.strConfigList;
        }

        if (listConfig.defaultTopAmount != 25) {
            params.$top = listConfig.defaultTopAmount;
        }

        if (listConfig.intSkip) {
            params.$skip = listConfig.intSkip;
        }

        if (listConfig.strLocale) {
            params.device_locale = listConfig.strLocale;
        }

        if (filterListConfig) {
            if(filterListConfig.strSearch) {
                params.q = filterListConfig.strSearch;
            }

            if(filterListConfig.strCatId) {
                params.cat = filterListConfig.strCatId;
            }

            if(filterListConfig.strSponsorId) {
                params.sponsorId = filterListConfig.strSponsorId;
            }

            if(filterListConfig.strCenter) {
                params.center = filterListConfig.strCenter;
            }
        }

        // var url = this.config().bzbsUrl + '/api/redeem';
        var url = this.config().newBzbsUrl + '/redeem';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, bzbsToken, params).then((response) => {
                var purchases = [];
                for (var item of response.data) {
                    var purchase = new PurchaseModel (item);
                    purchases.push(purchase);
                }

                resolve(purchases);
            }).catch((error) => {
                reject(error);
            });
        });
    },

    /**
     * @param {String} token
     * @param {String} redeemKey
     */
    apiRedeemUse: function (token, redeemKey) {
        var params = {};

        // var url = this.config().bzbsUrl + '/api/redeem/' + redeemKey + '/use';
        var url = this.config().newBzbsUrl + '/redeem/' + redeemKey + '/use';
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, token, params).then((response) => {
                resolve(response.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}
